import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { CampaignBannerWidget } from './CampaignBannerWidget'

class HoldstyringCampaignBannerElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return CampaignBannerWidget
  }

  // Supported HTML attributes:
  //   override-title="..."  — overrides admin-set banner title for this embed
  protected getWidgetProps() {
    return {
      overrideTitle: this.getAttribute('override-title') || null,
    }
  }
}

if (!customElements.get('holdstyring-campaign-banner')) {
  customElements.define('holdstyring-campaign-banner', HoldstyringCampaignBannerElement)
}

export { HoldstyringCampaignBannerElement }
